module.exports = __webpack_public_path__ + "img/TZS09479.5bf115be.jpeg";